import React from 'react';

function Portfolio() {
  return (
    <section className="work-asymetic section-padding">
      <div className="container mt-100">
        <div className="caption">
          <div className="lg-text fw-300">
            <div className="text">Digital art</div>
            <div className="text">director</div>
            <div className="text">& designer</div>
          </div>
          <p>
            We combine forward-thinking design with modern technology to tell
            stories that transform and grow our partners brands.
          </p>
        </div>
        <div className="row">
          <div className="col-lg-3 offset-lg-3 items">
            <div className="item">
              <div className="img">
                <img src="/light/assets/imgs/works/1/q1.jpg" alt="" />
              </div>
              <div className="cont mt-30">
                <span className="opacity-7 text-u fz-13 ls1 mb-5">
                  August 2020
                </span>
                <h6>
                  <a href="/light/project1">Branding Design</a>
                </h6>
              </div>
            </div>
          </div>
          <div className="col-lg-6 items">
            <div className="item">
              <div className="img">
                <img src="/light/assets/imgs/works/1/q2.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-center mt-30">
                <h6>
                  <a href="/light/project2">Branding Design</a>
                </h6>
                <span className="opacity-7 text-u fz-13 ls1 ml-auto">
                  August 2020
                </span>
              </div>
            </div>
          </div>
          <div className="col-lg-6 items">
            <div className="item">
              <div className="img">
                <img src="/light/assets/imgs/works/1/q3.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-center mt-30">
                <h6>
                  <a href="/light/project3">Branding Design</a>
                </h6>
                <span className="opacity-7 text-u fz-13 ls1 ml-auto">
                  August 2020
                </span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 offset-lg-2 items d-flex align-items-end">
            <div className="item full-width">
              <div className="img">
                <img src="/light/assets/imgs/works/1/q4.jpg" alt="" />
              </div>
              <div className="cont mt-30">
                <span className="opacity-7 text-u fz-13 ls1 mb-5">
                  August 2020
                </span>
                <h6>
                  <a href="/light/project4">Branding Design</a>
                </h6>
              </div>
            </div>
          </div>
          <div className="col-lg-4 items">
            <div className="item">
              <div className="img">
                <img src="/light/assets/imgs/works/1/q5.jpg" alt="" />
              </div>
              <div className="cont mt-30">
                <span className="opacity-7 text-u fz-13 ls1 mb-5">
                  August 2020
                </span>
                <h6>
                  <a href="/light/project5">Branding Design</a>
                </h6>
              </div>
            </div>
          </div>
          <div className="col-lg-6 offset-lg-2">
            <div className="row lg-marg">
              <div className="col-lg-6 items">
                <div className="item">
                  <div className="img">
                    <img src="/light/assets/imgs/works/1/q6.jpg" alt="" />
                  </div>
                  <div className="cont mt-30">
                    <span className="opacity-7 text-u fz-13 ls1 mb-5">
                      August 2020
                    </span>
                    <h6>
                      <a href="/light/project6">Branding Design</a>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 items">
                <div className="item">
                  <div className="img">
                    <img src="/light/assets/imgs/works/1/q7.jpg" alt="" />
                  </div>
                  <div className="cont mt-30">
                    <span className="opacity-7 text-u fz-13 ls1 mb-5">
                      August 2020
                    </span>
                    <h6>
                      <a href="/light/project1">Branding Design</a>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 items d-flex align-items-end">
            <div className="item full-width">
              <div className="img">
                <img src="/light/assets/imgs/works/1/q8.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-center mt-30">
                <h6>
                  <a href="/light/project2">Branding Design</a>
                </h6>
                <span className="opacity-7 text-u fz-13 ls1 ml-auto">
                  August 2020
                </span>
              </div>
            </div>
          </div>
          <div className="col-lg-7 offset-lg-1 items">
            <div className="item">
              <div className="img">
                <img src="/light/assets/imgs/works/1/q9.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-center mt-30">
                <h6>
                  <a href="/light/project3">Branding Design</a>
                </h6>
                <span className="opacity-7 text-u fz-13 ls1 ml-auto">
                  August 2020
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
